import React from 'react';

/** Small inline glyphs used across the Lair screens (inherit currentColor). */
export const PowerIcon = ({ className = 'lair-glyph' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path fill="currentColor" d="M13.5 2 4 13.5h6.5L9.5 22 20 9.5h-6.6L13.5 2z" />
  </svg>
);

export const ClockIcon = ({ className = 'lair-glyph' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2.4" />
    <path d="M12 7v5.2l3.4 2" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
  </svg>
);

export const ChanceIcon = ({ className = 'lair-glyph' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="2.4" />
    <circle cx="12" cy="12" r="4.2" fill="none" stroke="currentColor" strokeWidth="2.4" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" />
  </svg>
);

export const LockIcon = ({ className = 'lair-glyph' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="4.5" y="10.5" width="15" height="11" rx="2.6" fill="currentColor" />
    <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" fill="none" stroke="currentColor" strokeWidth="2.4" />
  </svg>
);

export const BackIcon = ({ className = 'lair-glyph' }) => (
  <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
    <path d="M15 4.5 7.5 12l7.5 7.5" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
